// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,StatsGraph, ScoreCard,GameTypeTab
}                         from '../../../components';

class PartnerReports extends PureComponent {
  static propTypes = {
    earningGraphLabels:   PropTypes.array,
    revenueChart:  PropTypes.shape({
      headers: PropTypes.array,
      data: PropTypes.array
    }),
    earningGraphDatasets: PropTypes.array,
    teamMatesIsFetching:  PropTypes.bool,
    teamMates:            PropTypes.arrayOf(
      PropTypes.shape({
        picture:      PropTypes.string,
        firstname:    PropTypes.string,
        lastname:     PropTypes.string,
        profile:      PropTypes.string,
        profileColor: PropTypes.oneOf(['danger', 'warning', 'info', 'success'])
      })
    ),
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('PartnerReports');
  }

  componentDidMount() {
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
      }
    } = this.props;

  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('PartnerReports');
  }

  render() {
    const {
      statsTable,
      scoreCard
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
      }
    } = this.props;

    return(
      <div>
        <div className="row">
          <StatsTable bigTable={true} name="walk_in_leads_per_day" displayName="Walk-In Leads per day" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>

        <div className="row" >
          <StatsTable bigTable={true} name="court_utilization" displayName="Court Utilization Details" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
        <div className="row" >
          <StatsTable bigTable={true} name="check_details" displayName="Checkin/CheckOut Details" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
        <div className="row">
          <StatsTable bigTable={true} datefilter={false} end_date={false} name="leads_Added_per_day" displayName="Leads added per Day" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
        <div className="row">
          <StatsTable bigTable={true} datefilter={true} end_date={true} name="buddy_allocation" displayName="Buddy Allocation" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
        <div className="row">
          <StatsTable bigTable={true} datefilter={false} end_date={false} name="court_usage_daily_data" displayName="Court usage Daily" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
        <div className="row">
          <StatsTable bigTable={true} name="buddy_attendance_daily" displayName="Buddy attendence" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>

        <div className="row">
          <StatsTable bigTable={true} datefilter={true} end_date={false} game_type_id={4} name="sessions_lists" displayName="Improve Sessions" color="#29ea92" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>

      </div>
    );
  }
}

export default PartnerReports;



// WEBPACK FOOTER //
// ./src/app/views/partner/partnerReports/PartnerReports.js